import { mailRegexs } from "../../../../../constants/mailTemplateConstants";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { getHHmmFormat } from "../../../../../helper/dateTimeHelper";
import { MailService } from "../../../../../services/mail/mail.service";
import { getEnv } from "../../../../../AppConfigs";
import { department as departments } from "../../../info-technology-process/data";

const siteUrl = getEnv("REACT_APP_SUMMARY_EMPLOYEE_REQUEST");

export const approveRequestEmail = async (
  detail: any,
  mailType: string,
  approver: string,
  mailtemplates: any,
  department: string
) => {
  let url = siteUrl + "/details/" + detail.id;

  if (department) {
    const departmentCode = departments.filter(
      // eslint-disable-next-line eqeqeq
      (value) => value.value == department
    )[0].id;

    url =
      siteUrl +
      "/details/" +
      detail.id +
      `?fromEmail=${1}&eDepartment=${departmentCode}`;
  }

  const eSubRequestsStatus = JSON.parse(detail.fields.eSubRequestsStatus);

  const arr = approver.split("|");
  let tomail = arr.length > 0 ? arr[0] : "";
  let name = arr.length > 1 ? arr[1] : "";
  const template = mailtemplates.find((m: any) => m.eMailType === mailType);
  let content = "";

  if (mailType[3].toLowerCase() === "r") {
    tomail = detail?.createdBy?.user?.email || "";
    name = detail?.createdBy?.user?.displayName || "";

    if(eSubRequestsStatus[department]){
      tomail = eSubRequestsStatus[department].createdEmail || ""
      name = eSubRequestsStatus[department].createdName || ""
    }
  }

  if (mailType[3].toLowerCase() === "f") {
    tomail = detail?.createdBy?.user?.email || "";
    name = detail?.createdBy?.user?.displayName || "";

    if(eSubRequestsStatus[department]){
      tomail = eSubRequestsStatus[department].createdEmail || ""
      name = eSubRequestsStatus[department].createdName || ""
    }

    content = template.eContent
      .replace(mailRegexs.zero, name)
      .replace(mailRegexs.one, "");
  } else {
    content = template.eContent
      .replace(mailRegexs.zero + ";", name)
      .replace(mailRegexs.one + ";", "duyệt")
      .replace(mailRegexs.two + ";", detail?.createdBy?.user?.displayName)
      .replace(
        mailRegexs.three + ";",
        `${getDDMMYYYFormat(detail.createdDateTime)} - ${getHHmmFormat(
          detail.createdDateTime
        )}`
      )
      .replace(mailRegexs.siteUrl, url);
  }

  const subject = template.eSubject;
  const message = MailService.buildMailMesssage(
    subject,
    content,
    "html",
    tomail
  );
  await MailService.sendMail(message);
};

export const sendEmail = async (
  detail: any,
  mailType: string,
  approver: string,
  mailtemplates: any,
  department: string,
  siteUrl: string,
  comment?: string,
  isOldURL?:boolean
) => {
  let url = siteUrl + "/detail/" + detail.id;
  if (isOldURL) {
    url = siteUrl + "/details/" + detail.id;
  }

  if (department) {
    const departmentCode = departments.filter(
      // eslint-disable-next-line eqeqeq
      (value) => value.value == department
    )[0].id;

    url =
      siteUrl +
      "/detail/" +
      detail.id +
      `?fromEmail=${1}&eDepartment=${departmentCode}`;
  }

  const arr = approver.split("|");
  let tomail = arr.length > 0 ? arr[0] : "";
  let name = arr.length > 1 ? arr[1] : "";
  const template = mailtemplates.find((m: any) => m.eMailType === mailType);
  let content = "";

  if (mailType[mailType.length - 1].toLowerCase() === "r") {
    tomail = detail?.createdBy?.user?.email || "";
    name = detail?.createdBy?.user?.displayName || "";
  }

  if (mailType[mailType.length - 1].toLowerCase() === "f") {
    tomail = detail?.createdBy?.user?.email || "";
    name = detail?.createdBy?.user?.displayName || "";

    content = template.eContent
      .replace(mailRegexs.zero, name)
      .replace(mailRegexs.one, comment || "");
  } else {
    content = template.eContent
      .replace(mailRegexs.zero + ";", name)
      .replace(mailRegexs.one + ";", "duyệt")
      .replace(mailRegexs.two + ";", detail?.createdBy?.user?.displayName)
      .replace(
        mailRegexs.three + ";",
        `${getDDMMYYYFormat(detail.createdDateTime)} - ${getHHmmFormat(
          detail.createdDateTime
        )}`
      )
      .replace(mailRegexs.siteUrl, url);
  }

  const subject = template.eSubject;
  const message = MailService.buildMailMesssage(
    subject,
    content,
    "html",
    tomail
  );
  try {
    await MailService.sendMail(message);
  } catch (error) {
    console.log({ error });
  }
};
